import { render, staticRenderFns } from "./AddShortlistModal.vue?vue&type=template&id=0b39a4ea&"
import script from "./AddShortlistModal.vue?vue&type=script&lang=js&"
export * from "./AddShortlistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports